import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const KoachSales: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // 판매 메인 페이지 접근 시 상품 관리로 리다이렉트
        navigate('/koach/sales/product', { replace: true });
    }, [navigate]);

    return null;
};

export default KoachSales;

